import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined';
import { Button, Table, Tooltip } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link } from 'react-router-dom';
import coachApi from '../../../apis/CoachApi';
import LayoutComponent from '../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../context/CustomContext';
import { LegacyPage } from '../../../model/Elements';
import { Coach } from '../../../model/Entities';
import notificationService from '../../../services/NotificationService';
import tableService from '../../../services/TableService';
import styles from './CoachesPage.module.scss';

class CoachesPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
            const coachesPage = await coachApi.listAll(0, tableService.pageSize, 'id', true);
            this.setState({ coachesPage });
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    };

    list = async (pagination: TablePaginationConfig, sorter: any) => {
        try {
            this.setState({ loading: true });
            const page = pagination.current!;
            const pageSize = pagination.pageSize!;
            const sortField = sorter.field;
            const sortOrder = sorter.order === 'ascend';
            const coachesPage = await coachApi.listAll(page - 1, pageSize, sortField, sortOrder);
            this.setState({ coachesPage });
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
            this.setState({ loading: false });
        }
    };

    search = async () => {
        const { coachesPage } = this.state;
        try {
            this.setState({ loading: true });
            const pageSize = coachesPage!.size;
            const sortField = coachesPage!.sort.field!;
            const sortOrder = coachesPage!.sort.order!;
            const coachesPageNew = await coachApi.listAll(0, pageSize, sortField, sortOrder);
            this.setState({ coachesPage: coachesPageNew });
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
            this.setState({ loading: false });
        }
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        return (
            <>
                {this.renderToolbar()}
                <div className={styles.table}>
                    {this.renderTable()}
                </div>
            </>
        );
    };

    renderToolbar = (): React.ReactElement | undefined => {
        return (
            <div className={styles.toolbar}>
                <h1><FormattedMessage id="coach.title" /></h1>
                <Link to="/admin/coaches/new">
                    <Tooltip title={<FormattedMessage id="coach.tooltip" />}>
                        <Button type="primary" size="large" className={styles.add} icon={<PlusOutlined />}>
                            <FormattedMessage id="coach.add" />
                        </Button>
                    </Tooltip>
                </Link>
            </div>
        );
    };

    renderTable = (): React.ReactElement | undefined => {
        const { coachesPage, loading } = this.state;
        const items = coachesPage ? coachesPage.content : [];
        const columns: ColumnsType<Coach> = [
            {
                title: <FormattedMessage id="coach.firstName" />,
                dataIndex: 'firstName',
                key: 'firstName',
                sorter: true,
                render: (value: string, coach: Coach) => <Link to={`/admin/coaches/${coach.id}`}>{value}</Link>,
            },
            {
                title: <FormattedMessage id="coach.lastName" />,
                dataIndex: 'lastName',
                key: 'lastName',
                sorter: true,
                render: (value: string, coach: Coach) => <Link to={`/admin/coaches/${coach.id}`}>{value}</Link>,
            },
        ];

        return (
            <Table
                dataSource={items}
                columns={columns}
                pagination={tableService.createLegacyPagination(coachesPage)}
                rowKey="id"
                onChange={this.list}
                sortDirections={['ascend']}
                showSorterTooltip={false}
                loading={loading}
            />
        );
    };

    render() {
        return <LayoutComponent page="admin-coaches" content={this.renderContent} />;
    }
}
export default injectIntl(CoachesPage);

interface Props extends WrappedComponentProps {}

interface State {
    coachesPage?: LegacyPage<Coach>;
    loading?: boolean;
}
